export default __webpack_public_path__ + "static/media/SSO.b797a269.png";